import * as types from '../types'

/**
 * 关于我们
 * @type {Object}
 */
const state = {
    thumb: 'https://statics.yw0511.com/web/imgs/about-1.jpg',
    tabs: [
        {
            id: 1,
            title: '理念'
        },
        {
            id: 2,
            title: '许诺'
        },
        {
            id: 3,
            title: '特点'
        }
    ],
    content: [
        [
            {
                id: 11,
                type: 1,
                content: '原味理念</br>商业 社会 文化'
            },
            {
                id: 1,
                type: 2,
                content: '我们的价值不单单是提供真正安全、新鲜的当季当地食材的配送到家服务，我们更是将国外的农业可持续化先进理念和互联网技术落地生根，重构了一个“看得见的区域内”生产者和消费者之间长久信任关系的体系，并努力将其惠及到更多的人和地方！'
            },
            {
                id: 2,
                type: 3,
                content: 'https://statics.yw0511.com/web/imgs/idea-1.jpg?v=0x04'
            },
            {
                id: 3,
                type: 2,
                content: '我们想要重组消费者和生产者之间看得见的信任关系，连接田野中的农夫和城市里的人们。这是一段共生的过程，存在于泥土和嘴巴之间。'
            },
            {
                id: 4,
                type: 3,
                content: 'https://statics.yw0511.com/web/imgs/idea-2.jpg?v=0x04'
            },
            {
                id:5,
                type: 2,
                content: '我们旨在恢复一个生产者和消费者在“看得见”的体系内构建长久的信任关系，生产者为消费者生命担责任，消费者为生产者生活尽义务。'
            },
            {
                id: 5,
                type: 3,
                content: 'https://statics.yw0511.com/web/imgs/idea-3.jpg?v=0x04'
            },
            {
                id: 6,
                type: 2,
                content: '我们期望国外可持续农业的理念和技术，通过原味生活落地生根；'
            },
            {
                id: 7,
                type: 2,
                content: '原味生活生态信任农业模式能扎扎实实的解决一部分人的食品安全问题；'
            },
            {
                id: 8,
                type: 2,
                content: '呼吁消费者关注农村和农户，呼吁农户逐步降低和不使用农药及化学物质，恢复田间的生态；'
            },
            {
                id: 9,
                type: 2,
                content: '能缩短田间和餐桌之间的落差，让消费者收获美味和人情。'
            },
            {
                id: 10,
                type: 3,
                content: 'https://statics.yw0511.com/web/imgs/idea-4.jpg?v=0x04'
            }
        ],
        [
            {
                id: 1,
                type: 1,
                content: '有名有姓的蔬菜'
            },
            {
                id: 2,
                type: 2,
                content: '在这里，所有的食材都有一个具体的姓名，相同的品种因为管理的不同味道也会迥异，我们对农户和基地保持着较高频率的走访、监督和检测，让食物源头的生产者直接互动。'
            },
            {
                id: 3,
                type: 3,
                content: 'https://statics.yw0511.com/web/imgs/promise-1.jpg?v=0x03'
            },
            {
                id: 4,
                type: 1,
                content: '本地自然好食'
            },
            {
                id: 5,
                type: 2,
                content: '我们推崇“吃在当季、吃在当地、吃在当天”的生活方式，能做到“当天采摘、当天捕捞、当天宰杀、当天到家”，保持食物极致的鲜度，只有本地化供应体系才能实现。'
            },
            {
                id: 6,
                type: 3,
                content: 'https://statics.yw0511.com/web/imgs/promise-2.jpg?v=0x03'
            },
            {
                id: 7,
                type: 1,
                content: '给食物做身体检查'
            },
            {
                id: 8,
                type: 2,
                content: '除草药、杀虫剂、重金属污染物、真菌毒素、兽药、激素及有害微生物等，种种你想也想不透、防也防不住的问题，在专业的第三方检测机构定期抽样检测下都将无所遁形，并实时在平台公布、打印出来发布给每一位需要的消费者；话放在这，就是真的会这么干，专业的检测很贵，但贵不过许下的诺言。认真是很麻烦的，但麻烦之后，担心也就免了。'
            },
            {
                id: 9,
                type: 3,
                content: 'https://statics.yw0511.com/web/imgs/promise-3.jpg?v=0x03'
            },
            {
                id: 10,
                type: 1,
                content: '当天采摘</br>当天补捞'
            },
            {
                id: 11,
                type: 2,
                content: '最早的农户从凌晨1点开始，马不停蹄的分拣、包装、称重、打标签、宰杀、分割、装车、配送，确保到你手上接近极致的鲜度。'
            },
            {
                id: 12,
                type: 3,
                content: 'https://statics.yw0511.com/web/imgs/promise-4.jpg?v=0x03'
            },
            {
                id: 13,
                type: 1,
                content: '不喜欢就找我'
            },
            {
                id: 14,
                type: 2,
                content: '如果你有任何不愉快，请在到货后48小时内联系我们，我们很重视你的心情，也愿意聆听你的意见，做一些改变。'
            }
        ],
        [
            {
                id: 1,
                type: 3,
                content: 'http://cdn.yw0511.net/trust_all.jpg'
            }
        ]
    ]
}

const getters = {

}

const mutations = {
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/about.js